<router-outlet></router-outlet>
<app-toasters></app-toasters>
<app-loader></app-loader>

@if (isLoadingAction) {
<app-overlay-loading-spinner></app-overlay-loading-spinner>
}